var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExpel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mqvbm6auga)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm5.322 8.915C16.22 20.6 17 19.455 17 18.308c0-1.076-.42-1.913-1.1-2.551C14.54 14.479 12.14 14 10 14c-3.21 0-7 1.077-7 4.308C3 19.654 4.077 21 5.154 21h9.692a1.429 1.429 0 0 0 .476-.085z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.67 7.672a.75.75 0 0 0-1.06 0L18.842 9.44l-1.768-1.768a.75.75 0 0 0-1.06 1.06l1.767 1.769-1.768 1.767a.75.75 0 0 0 1.061 1.061l1.768-1.768 1.768 1.768a.75.75 0 0 0 1.06-1.06L19.902 10.5l1.768-1.768a.75.75 0 0 0 0-1.06z",
    fill: "#EE6762"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mqvbm6auga"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpel);
export default __webpack_public_path__ + "static/media/icon_expel.97f0d7032ec7c4e9b6746b004ff15677.svg";
export { ForwardRef as ReactComponent };